import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { Toaster } from "sonner";
import { Navbar } from "@/components/site/Navbar";
import { Footer } from "@/components/site/Footer";
import { LightboxProvider } from "@/components/site/Lightbox";
import Home from "@/pages/Home";
import BlogPost from "@/pages/BlogPost";

function App() {
  return (
    <div className="App grain min-h-screen bg-bone text-ink">
      <BrowserRouter>
        <LightboxProvider>
          <Navbar />
          <main className="relative z-10">
            <Routes>
              <Route path="/" element={<Home />} />
              <Route path="/journal/:slug" element={<BlogPost />} />
            </Routes>
          </main>
          <Footer />
        </LightboxProvider>
        <Toaster
          position="bottom-right"
          toastOptions={{
            style: {
              background: "#1A1A18",
              color: "#F7F5F0",
              border: "1px solid #D4A373",
              borderRadius: 0,
              fontFamily: "Outfit, sans-serif",
            },
          }}
        />
      </BrowserRouter>
    </div>
  );
}

export default App;
